import { Injectable, inject } from '@angular/core';
import { SharedModuleConfig } from '@shared/config/module';
import {
  AdminModuleConfig,
  App,
  FaqModuleConfig,
  FormService,
  LoginModuleConfig,
  ModuleService,
  NotificationModuleConfig,
  ProfileModuleConfig,
  ProjectService,
  ProjectmanagementModuleConfig,
  ProjectselectionModuleConfig,
} from '@simac/ui';
import { CustomWebshopModuleConfig, WebshopModuleConfig } from '@webshop/shared/config/module';
import { WebshopManagerModuleConfig } from '@webshop/webshopmanagement/config/module';
import { FieldSupportModuleConfig } from 'src/app/features/fieldsupport/shared/module';
import { ItsmModuleConfig } from 'src/app/features/itsm/shared/module';
import { ServiceAndSupportModuleConfig } from 'src/app/features/serviceandsupport/shared/config/module';
import { SspManagerModuleConfig } from 'src/app/features/serviceandsupport/ssp-manager/config/module';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  private readonly moduleService = inject(ModuleService);
  private readonly projectService = inject(ProjectService);
  private readonly formService = inject(FormService);

  registerModules(): void {
    this.setModuleIcons();

    this.moduleService.addModules(LoginModuleConfig, ProjectselectionModuleConfig, ProfileModuleConfig, NotificationModuleConfig, ProjectmanagementModuleConfig, AdminModuleConfig);
    this.addFormModule();
    this.moduleService.addModule(ServiceAndSupportModuleConfig);
    this.moduleService.addModule(FaqModuleConfig);
    this.moduleService.addModule(FieldSupportModuleConfig);
    this.moduleService.addModule(WebshopModuleConfig);
    this.moduleService.addModule(WebshopManagerModuleConfig);
    this.moduleService.addModule(CustomWebshopModuleConfig);
    this.moduleService.addModule(ItsmModuleConfig);
    this.moduleService.addModule(SharedModuleConfig);
    this.moduleService.addModule(SspManagerModuleConfig);
  }

  setModuleIcons(): void {
    const moduleIcons: Record<string, string> = {
      ServiceAndSupportModule: 'far fa-comments-question-check',
      WebshopModule: 'far fa-shop',
      ItsmModule: 'far fa-sync',
    };
    this.projectService.setModuleIcons(moduleIcons);
  }

  private addFormModule(): void {
    this.formService.addModule({
      app: App.MySimac,
      apiPrefix: 'api/serviceandsupport',
      moduleName: 'ServiceAndSupport',
    });
  }
}
